export default __webpack_public_path__ + "ac056496cb7244af5b3c514c7c1a6e53.svg";